export interface IGetLocationByIdFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
